/* hx-menu v2: mobile drawer and desktop mega panel behaviour.
   Vanilla JS, no dependencies. Loaded from sections/header.liquid only when the
   header link list is main-menu-2026, so the live menu is never affected. */
(function () {
  var d = document;
  function qs(s, r) { return (r || d).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }

  d.documentElement.classList.add('hxm-js');

  /* ------------------------------------------------------------------ drawer */
  var drawer = qs('#hxm-drawer');
  var backdrop = qs('#hxm-backdrop');
  var openBtn = qs('#hxm-open');
  var closeBtn = qs('#hxm-close');
  var groups = drawer ? qsa('[data-hxm-grp]', drawer) : [];
  var hideTimer = null;

  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),summary,[tabindex]:not([tabindex="-1"])';

  function drawerIsOpen() { return !!drawer && drawer.classList.contains('is-open'); }

  /* ------------------------------------------------------------------- warm
     Row thumbnails are lazy and sit inside panels that start hidden, so the
     browser only begins fetching them the moment a panel opens. That showed
     empty circles for a beat on the first open. Drop the lazy flag once the
     page is idle, and again on the first sign of intent, so the images are
     already in cache. Nothing is fetched before load, so LCP is untouched. */
  var hxmWarmed = false;
  function hxmWarm() {
    if (hxmWarmed) return;
    hxmWarmed = true;
    qsa('img.hxm-th').forEach(function (img) {
      /* Only warm the menu the visitor can actually reach. A phone hides the
         desktop mega menu and a desktop hides the drawer, and dropping the
         lazy flag on the hidden half downloaded about 250 KB of thumbnails
         nobody would ever see. */
      var host = img.closest ? img.closest('.hxm-d, #hxm-drawer') : null;
      if (host && window.getComputedStyle(host).display === 'none') return;
      img.removeAttribute('loading');
    });
  }
  function hxmScheduleWarm() {
    if (window.requestIdleCallback) window.requestIdleCallback(hxmWarm, { timeout: 3000 });
    else setTimeout(hxmWarm, 1200);
  }
  if (d.readyState === 'complete') hxmScheduleWarm();
  else window.addEventListener('load', hxmScheduleWarm);
  if (openBtn) {
    openBtn.addEventListener('pointerenter', hxmWarm);
    openBtn.addEventListener('touchstart', hxmWarm, { passive: true });
  }


  function drawerOpen() {
    if (!drawer || !backdrop) return;
    if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
    backdrop.hidden = false;
    void backdrop.offsetHeight; /* force a frame so the fade runs */
    drawer.classList.add('is-open');
    backdrop.classList.add('is-open');
    d.body.classList.add('hxm-locked');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    window.setTimeout(function () { if (closeBtn) closeBtn.focus(); }, 30);
  }

  function drawerClose(returnFocus) {
    if (!drawer || !backdrop) return;
    drawer.classList.remove('is-open');
    backdrop.classList.remove('is-open');
    d.body.classList.remove('hxm-locked');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    hideTimer = window.setTimeout(function () { backdrop.hidden = true; }, 300);
    if (returnFocus && openBtn) openBtn.focus();
  }

  if (drawer && backdrop) {
    if (openBtn) openBtn.addEventListener('click', drawerOpen);
    if (closeBtn) closeBtn.addEventListener('click', function () { drawerClose(true); });
    backdrop.addEventListener('click', function () { drawerClose(true); });

    /* one accordion open at a time */
    groups.forEach(function (group) {
      group.addEventListener('toggle', function () {
        if (!group.open) return;
        groups.forEach(function (other) { if (other !== group && other.open) other.open = false; });
      });
    });

    /* focus trap: Tab cycles inside the drawer while it is open */
    drawer.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab' && event.keyCode !== 9) return;
      if (!drawerIsOpen()) return;
      var items = qsa(FOCUSABLE, drawer).filter(function (el) {
        return el.offsetWidth || el.offsetHeight || el.getClientRects().length;
      });
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && d.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && d.activeElement === last) { event.preventDefault(); first.focus(); }
    });
  }

  /* ---------------------------------------------------------- desktop panels */
  var items = qsa('[data-hxm-d-item]');
  var current = null;
  var openTimer = null;
  var closeTimer = null;

  function panelOpen(item) {
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    if (current && current !== item) panelClose(current);
    item.classList.add('is-open');
    var trigger = qs('[data-hxm-d-trigger]', item);
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    current = item;
  }

  function panelClose(item) {
    if (!item) return;
    item.classList.remove('is-open');
    var trigger = qs('[data-hxm-d-trigger]', item);
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (current === item) current = null;
  }

  items.forEach(function (item) {
    /* hover intent: a short delay in, a longer one out */
    item.addEventListener('mouseenter', function () {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      if (openTimer) clearTimeout(openTimer);
      openTimer = window.setTimeout(function () { panelOpen(item); }, 110);
    });
    item.addEventListener('mouseleave', function () {
      if (openTimer) { clearTimeout(openTimer); openTimer = null; }
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = window.setTimeout(function () { panelClose(item); }, 220);
    });

    /* click toggles the panel; clicking the same link again follows it */
    var trigger = qs('[data-hxm-d-trigger]', item);
    if (trigger) {
      trigger.addEventListener('click', function (event) {
        if (item.classList.contains('is-open')) return; /* second click navigates */
        event.preventDefault();
        panelOpen(item);
      });
    }

    /* keyboard: tabbing in opens the panel, tabbing out of it closes it */
    item.addEventListener('focusin', function () { panelOpen(item); });
    item.addEventListener('focusout', function (event) {
      var next = event.relatedTarget;
      if (!next || !item.contains(next)) panelClose(item);
    });
  });

  /* ------------------------------------------------------------------ escape */
  d.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' && event.keyCode !== 27) return;
    if (drawerIsOpen()) drawerClose(true);
    if (current) {
      var item = current;
      var trigger = qs('[data-hxm-d-trigger]', item);
      var inside = item.contains(d.activeElement);
      panelClose(item);
      if (trigger && inside) trigger.focus();
    }
  });

  /* ------------------------------------------ QA flag, preview themes only
     ?hxmenu=open opens the drawer with the first group expanded and opens the
     first desktop panel, so the menu can be screenshotted headlessly.
     ?hxmenu=open&hxgrp=3 opens the group and panel at that index instead.
     Both are ignored on the published theme. */
  try {
    var params = new URLSearchParams(window.location.search);
    if (params.get('hxmenu') === 'open') {
      var role = (window.Shopify && window.Shopify.theme && window.Shopify.theme.role) || '';
      var isPreview = role !== 'main' || params.has('preview_theme_id');
      if (isPreview) {
        var n = parseInt(params.get('hxgrp'), 10);
        if (isNaN(n) || n < 0) n = 0;
        if (groups[n]) groups[n].open = true;
        drawerOpen();
        if (items[n]) panelOpen(items[n]);
      }
    }
  } catch (e) { /* no query string support, nothing to do */ }
})();
